import { z } from 'zod'

import { DateStringSchema, type ZodInfer } from '@mntn-dev/utility-types'

import { UnitSchema } from '../billing/unit.ts'
import { PaymentTypeSchema } from '../invoice.models.ts'
import { OrganizationIdSchema, ProjectIdSchema } from '../unique-id.models.ts'
import { PaymentIdSchema } from './payment-id.ts'
import { PaymentStatusSchema } from './payment-status.ts'
import { TipaltiIdSchema } from './tipalti-id.ts'

export const PaymentSchema = z.object({
  createdTime: DateStringSchema.optional(),
  updatedTime: DateStringSchema.optional(),
  paymentId: PaymentIdSchema,
  paymentType: PaymentTypeSchema,
  organizationId: OrganizationIdSchema,
  projectId: ProjectIdSchema,
  tipaltiId: TipaltiIdSchema,
  unit: UnitSchema,
  amount: z.number(),
  status: PaymentStatusSchema,
})

export type Payment = ZodInfer<typeof PaymentSchema>
